import { announcements } from './Announcements/Announcements.i18n.en'
import { attendanceLogs } from './AttendanceLogs/AttendanceLogs.i18n.en'
import { employees } from './Employees/Employees.i18n.en'
import { idCards } from './IdCards/IdCards.i18n.en'
import { languages } from './Languages/Languages.i18n.en'
import { terminals } from './Terminals/Terminals.i18n.en'
import { uniforms } from './Uniforms/Uniforms.i18n.en'

export const pages = {
  announcements,
  attendanceLogs,
  employees,
  idCards,
  languages,
  terminals,
  uniforms,
}
